export default __webpack_public_path__ + "static/media/Snd_01.9d6a26cc.mp3";